const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/layout/PageLayout.tsx';
import { css } from '@emotion/css';
import { Box, Container } from '@mui/material';
import useBreakpoint from '@cistec/common_web/hooks/useBreakpoint';
import { Footer } from 'App/components/Footer/Footer';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';

export interface IPageLayoutProps {
    appBar: any;
    children?: any;
    disableVerticalScrolling?: boolean;
    noPaddingAroundContent?: boolean;
}

function useCSSClasses(props: IPageLayoutImplProps) {
    const theme = useTheme();
    return useMemo(
        () => ({
            pageLayoutRootStyle: css`
                display: flex;
                flex-direction: column;
                height: 100%;
                overflow-y: auto;
            `,
            scrollableStyle: css`
                flex: 1 1 100%;
                overflow-x: hidden;
                overflow-y: ${props.disableVerticalScrolling ? 'hidden' : 'auto'};
                position: relative;
                background: ${theme.palette.background.default};

                ${theme?.breakpoints?.down && theme.breakpoints.down('md')} {
                    // this causes the footer to stick at the bottom
                    display: flex;
                    flex-direction: column;
                }
            `,
        }),
        [theme, props.disableVerticalScrolling]
    );
}

type IPageLayoutImplProps = IPageLayoutProps;

export const PageLayout = (props: IPageLayoutImplProps) => {
    const { children, noPaddingAroundContent, appBar } = props;
    const classes = useCSSClasses(props);
    const theme = useTheme();
    const isMediumDevice = useBreakpoint(theme?.breakpoints?.values?.md);

    const wrappedContent = noPaddingAroundContent ? (
        props.children
    ) : (
        <Container maxWidth="md">
            <Box
                sx={{
                    pt: 2,
                }}
            />
            {children}
            <Box
                sx={{
                    pt: 2,
                }}
            />
        </Container>
    );

    return (
        <div className={classes.pageLayoutRootStyle}>
            {appBar}
            <div className={classes.scrollableStyle}>
                {wrappedContent}
                {isMediumDevice && <Footer />}
            </div>
        </div>
    );
};
